/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "host_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "cfa",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum BatchLiquidator.FlowType",
                        name: "agreementOperation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "receiver",
                        type: "address",
                    },
                ],
                internalType: "struct BatchLiquidator.FlowLiquidationData",
                name: "data",
                type: "tuple",
            },
        ],
        name: "deleteFlow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum BatchLiquidator.FlowType",
                        name: "agreementOperation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "receiver",
                        type: "address",
                    },
                ],
                internalType: "struct BatchLiquidator.FlowLiquidationData[]",
                name: "data",
                type: "tuple[]",
            },
        ],
        name: "deleteFlows",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "gda",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "host",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class BatchLiquidator__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host_, overrides) {
        return super.deploy(host_, overrides || {});
    }
    getDeployTransaction(host_, overrides) {
        return super.getDeployTransaction(host_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
BatchLiquidator__factory.bytecode = _bytecode;
BatchLiquidator__factory.abi = _abi;
//# sourceMappingURL=BatchLiquidator__factory.js.map